import { checkIsErrorToolOutput } from "@repo/app-types/agents/errorToolOutput";
import type {
  KbAdherenceFindingToolInput,
  KbAdherenceFindingToolOutput,
} from "@repo/app-types/entities/kbAdherenceFindingTool";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const GetKbAdherenceFindingTool: ToolComponent<
  KbAdherenceFindingToolInput,
  KbAdherenceFindingToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Retrieving finding details...";
    }

    if (checkIsErrorToolOutput(props.output)) {
      return "An error occurred while retrieving the finding";
    }

    if (!props.output.statement) {
      return "The finding was not found";
    }

    return "The finding was found";
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
